import MapController from './map-controller'

// Editable variant of the service-area map: the subject polygon lives in
// mapbox-gl-draw (draw one polygon, edit vertices, trash it) and mirrors
// into a hidden geo_json_feature form field. Siblings render through the
// parent controller and never enter the draw layer, so they stay read-only.
export default class extends MapController {
  static targets = ['canvas', 'geoJsonField']

  async renderSubject() {
    const { default: MapboxDraw } = await import('@mapbox/mapbox-gl-draw')
    this.draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: { polygon: true, trash: true },
    })
    this.map.addControl(this.draw)

    if (this.hasSubjectPolygon()) {
      this.draw.add(this.subjectFeature())
    }
    this.toggleDrawButton()

    this.map.on('draw.create', event => this.onDrawCreate(event))
    this.map.on('draw.update', () => this.syncField())
    this.map.on('draw.delete', () => {
      this.syncField()
      this.toggleDrawButton()
    })
  }

  // One polygon per service area: drop anything that isn't the newly drawn one
  onDrawCreate(event) {
    const createdIds = event.features.map(feature => feature.id)
    const staleIds = this.drawnFeatures()
      .map(feature => feature.id)
      .filter(id => !createdIds.includes(id))
    if (staleIds.length > 0) {
      this.draw.delete(staleIds)
    }

    this.syncField()
    this.toggleDrawButton()
  }

  syncField() {
    const features = this.drawnFeatures()
    this.geoJsonFieldTarget.value = features.length > 0 ? JSON.stringify(features[0]) : ''
  }

  toggleDrawButton() {
    const button = this.element.querySelector('.mapbox-gl-draw_polygon')
    if (!button) {
      return
    }

    button.style.display = this.drawnFeatures().length > 0 ? 'none' : ''
  }

  drawnFeatures() {
    return this.draw.getAll().features
  }
}
